function formatRichText(html) {
    if(html){

        


        // html 就是你要传进来地富文本参数
        // 去掉img标签里的style、width、height属性
        let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
                match = match.replace(/style="[^"]*"/gi, '')
                //console.log("sss", match);
                return match;
        });
        //console.log("ddd", newContent);
        // 修改所有style里的width属性为max-width:100%
        newContent = newContent.replace(/\<img/gi,
                '<img style="max-width:100%;height:auto;display:block;margin:0px auto;"');
        
        //修改img 的 src 属性
        newContent = newContent.replace(/src="([^"]+)"/gi, function(match, src) {
            console.log("图片src",match, src);
            if (src.indexOf('http') != -1) {
                return match;
            }
            let res =  match.replace(src, 'https://admin.qrf-alloy.com/' + src);
            console.log("图片123src",res);
            return res
        });


        // 去掉<br/>标签
        newContent = newContent.replace(/<br[^>]*\/>/gi, '');

        // console.log("格式化之后的富文本", newContent);
        // 返回 处理后地结果
        return newContent;
    }
}
function padZero(num) {
    return num < 10 ? `0${num}` : `${num}`;
}
function formatDate(date) {
    let time = new Date(date)
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const year = time.getFullYear();
    const monthIndex = time.getMonth();
    const month = months[monthIndex];
    return `${month} ${padZero(time.getDate())}, ${year}`;
}
function formatdayDate(date) {
    let time = new Date(date)
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const year = time.getFullYear();
    const monthIndex = time.getMonth();
    const month = months[monthIndex];
    return `${padZero(time.getDate())} ${month}.${year}`;
}
// 分割字符
function strToarr(str){
    if(str){
        let arr = str.split("&");
        return arr;
    }
}

export default{
    formatRichText:formatRichText,
    formatDate:formatDate,
    padZero:padZero,
    formatdayDate:formatdayDate,
    strToarr:strToarr
}